import { Stack } from "@mantine/core";

import PageWrapper from "../../../components/Page/PageWrapper";
import PageTitle from "../../../components/Page/PageTitle";
import { QueryBuilder } from "../../../components/QueryBuilder";
import Loader from "../../../components/loader/loader";

import { useSavedSearchView } from "./useSavedSearchView.logic";
import SavedSearchHeader from "./components/SavedSearchHeader";
import SavedSearchResultsTable from "./components/SavedSearchResultsTable";
import { useTranslation } from "react-i18next";

export default function SavedSearchViewPage() {
  const { ruleId } = useSavedSearchView();
  const { t } = useTranslation();

  if (!ruleId) {
    return (
      <PageWrapper>
        <Loader height="40vh" />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.savedSearch")} />
      <Stack gap="lg">
        <SavedSearchHeader ruleId={ruleId} />
        <QueryBuilder ruleId={ruleId} />
        <SavedSearchResultsTable ruleId={ruleId} />
      </Stack>
    </PageWrapper>
  );
}
